(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-sticky-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Cart drawer opener — runs after form submit succeeds.
     Dynamo/Prestige themes expose a global theme.cart.open() or
     dispatch a custom event on [data-cart-toggle].
     We listen for the native Shopify add-to-cart AJAX success and
     then trigger whatever drawer mechanism the theme uses. */

  var form = document.getElementById('{{ product_form_id }}');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    /* The native product-component.js handles the AJAX submission.
       We hook into the cart:add event which the Dynamo theme fires
       after a successful add-to-cart. */
  });

  /* Listen for the theme's cart events (Dynamo fires these) */
  document.addEventListener('cart:add', function() {
    openCartDrawer();
  });

  /* Fallback: intercept the ATC button click and watch for
     the loader disappearing as a signal the request completed */
  var atcBtn = document.getElementById('AddToCart--{{ section.id }}');
  if (atcBtn) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.target.classList && !m.target.classList.contains('is-loading')) {
          if (atcBtn.classList.contains('added')) {
            openCartDrawer();
          }
        }
      });
    });
    observer.observe(atcBtn, { attributes: true, attributeFilter: ['class'] });
  }

  function openCartDrawer() {
    /* Method 1: Dynamo theme toggle */
    var toggle = document.querySelector('[data-cart-toggle], [data-cart-drawer-toggle], .js-cart-open, [aria-controls="CartDrawer"]');
    if (toggle) { toggle.click(); return; }

    /* Method 2: Dispatch custom event that many themes listen to */
    document.dispatchEvent(new CustomEvent('cart:open'));

    /* Method 3: theme.cart API if exposed */
    if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') {
      window.theme.cart.open();
    }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
